import { apiClient } from "../apiClient";

export interface Trip {
  id: number;
  cityId: number;
  userId: number;
  userName: string;
  vehicleCode: number;
  vehicleName: string;
  lockCode: number;
  startTime: string;
  endTime: string;
  duration: number;
  distance: number;
  startStationCode: number;
  startStationName: string;
  endStationCode: number;
  endStationName: string;
  paymentId: number;
  paymentKey: string | null;
  amount: number;
  startupAmount: number;
  currency: string;
  status: string;
  ratingGrade: number | null;
  couponId?: number | null;
}

export interface TripListResponse {
  content: Trip[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface TripListParams {
  userId: number;
  page: number;
  size: number;
  startDate?: string;
  endDate?: string;
}

export interface Payment {
  id: number;
  key: string;
  userId: number;
  userName: string;
  amount: number;
  capturedAmount: number;
  walletCapturedAmount: number;
  currency: string;
  status: string;
  type: string;
  receiptUrl: string | null;
  vat: number;
  directPaymentFee: number;
  dateCreated: string;
  capturedDate: string;
  planType: string;
  cityId: number;
}

export interface PaymentListResponse {
  content: Payment[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface PaymentListParams {
  userId: number;
  page: number;
  size: number;
  startDate?: string;
  endDate?: string;
}

export const getTrips = (params: TripListParams): Promise<TripListResponse> => {
  const queryParams: Record<string, string | number> = {
    userId: params.userId,
    page: params.page,
    size: params.size,
    sort: "startTime,desc",
  };

  if (params.startDate) {
    queryParams.startDate = params.startDate;
  }
  if (params.endDate) {
    queryParams.endDate = params.endDate;
  }

  return apiClient
    .get("/journey-service/dashboard/journeys", { params: queryParams })
    .then((r) => r.data);
};

export const getPayments = (
  params: PaymentListParams
): Promise<PaymentListResponse> => {
  const queryParams: Record<string, string | number> = {
    search: params.userId,
    page: params.page,
    size: params.size,
    sort: "dateCreated,desc",
  };

  if (params.startDate) {
    queryParams.startDate = params.startDate;
  }
  if (params.endDate) {
    queryParams.endDate = params.endDate;
  }

  return apiClient
    .get("/payment-service/dashboard/payments", { params: queryParams })
    .then((r) => r.data);
};

export const getReceiptHtml = (paymentKey: string): Promise<string> =>
  apiClient
    .get(`/payment-service/receipts/${paymentKey}`, { responseType: "text" })
    .then((r) => r.data);

export const getActiveCoupons = (
  userId: number,
  cityId: number
): Promise<any[]> =>
  apiClient
    .get(`/coupon-service/dashboard/user-coupon/${userId}/${cityId}/active`)
    .then((r) => r.data);
